
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IStory } from '@/utils/types'
import StartSettingBtnSelector from '@/components/story/common/selectors/StartSettingBtnSelector.vue'
import { TRIGGER_TYPE } from '@/utils/constants'

@Options({
  components: { StartSettingBtnSelector },
  directives: { maska },
  emits: ['update:modelValue', 'update:selectedPushIndex', 'nextStep', 'deletePush', 'openStartSettings'],
})
export default class Stepper extends Vue {
  @Prop()
  modelValue!: number

  @Prop()
  form!: IStory

  @Prop()
  selectedPushIndex!: number

  @Prop({ default: false })
  isTestMode = false

  get value() {
    return this.modelValue
  }

  set value(value: number) {
    this.$emit('update:modelValue', value)
  }

  get pushIndex() {
    return this.selectedPushIndex
  }

  set pushIndex(value: number) {
    this.$emit('update:selectedPushIndex', value)
  }

  get isAddPopup() {
    if (this.isTestMode) {
      return this.form.campaign?.test_detail?.is_add_popup ?? true
    } else {
      return this.form.campaign?.prod_detail?.is_add_popup ?? true
    }
  }

  getDefaultTitlePush(index: number) {
    if (this.form.trigger_type === TRIGGER_TYPE.AUDIENCE) {
      return 'メッセージ：' + (index + 1)
    }
    return 'メッセージ：' + (index + 2)
  }

  nextStep() {
    this.$emit('nextStep')
  }

  selectPush(index: number) {
    this.value = 4
    this.pushIndex = index
  }

  deletePush(index: number) {
    this.$emit('deletePush', index)
  }

  openStartSettings(index) {
    this.value = 4
    this.pushIndex = index
    this.$emit('openStartSettings')
  }
}
